<template>
	<div class="clinic">
		<div class="clinic-navigate">
			<div class="clinic-left">
				<div v-for="(item,index) in navigate"
					:class="'clinic-item '+(navigateIndex!=item.id?'clinic-item-select':'')" :key="index"
					@click="changeCase(item.id)">
					<img src="../../../assets/icon_table_done@2x.png" v-if="navigateIndex!=item.id">
					<img src="../../../assets/icon_table_done_pre@2x.png" v-else>
					{{item.name}}
					<span>{{item.num}}</span>
					<div class="clinic-item-underline" v-if="navigateIndex==index"></div>
				</div>
			</div>
			<div class="clinic-right">
				<div class="clinic-item">
					<el-date-picker v-model="f" type="date" placeholder="受理日期" @change="fetchDataWithKeyword(keyword)"
						format="yyyy-MM-dd" value-format="yyyy-MM-dd" clearable>
					</el-date-picker>
				</div>
				<div class="clinic-item">
					<el-select v-model="typeVal" filterable placeholder="委托机构类型" @change="fetchDataWithKeyword(keyword)"
						clearable>
						<el-option v-for="(item,index) in type" :key="index" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</div>
				<div class="clinic-item">
					<el-select v-model="repeatVal" filterable placeholder="是否重新鉴定" clearable
						@change="fetchDataWithKeyword(keyword)">
						<el-option v-for="(item,index) in repeat" :key="index" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</div>
				<div class="clinic-item">
					<el-button icon="el-icon-printer" @click="exportCase">导出</el-button>
				</div>
			</div>
		</div>
		<div class="clinic-table" v-loading="loading" v-if="navigateIndex != 325">
			<el-table ref="multipleTable" :key="'normal'" :data="tableData" tooltip-effect="dark" width="100%"
				@selection-change="handleSelectionChange">
				<el-table-column type="selection" width="55">
				</el-table-column>
				<el-table-column prop="caseNo" label="编号" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="entrustmentName" label="委托人" align="center">
				</el-table-column>
				<el-table-column prop="contacts" label="联系人" align="center">
				</el-table-column>
				<el-table-column prop="phone" label="联系方式" align="center">
				</el-table-column>
				<el-table-column prop="entrustTime" label="受理时间" align="center">
				</el-table-column>
				<el-table-column prop="handler" label="经办人" align="center">
				</el-table-column>
				<el-table-column prop="entrustedMattersName" label="鉴定事项" width="400px;" align="center">
					<template slot-scope="scope">
						<el-link :underline="false" @click="editMatter(scope.$index, scope.row)">
							{{scope.row.entrustedMattersName==null?'无-请点击修改':scope.row.entrustedMattersName}}
						</el-link>
					</template>
				</el-table-column>
				<el-table-column label="操 作" align="center" width="300px;">
					<template slot-scope="scope">
						<el-link icon="el-icon-document" :underline="false"
							@click="handleCheck(scope.$index, scope.row)">查 看</el-link>
						<el-link icon="el-icon-circle-close" :underline="false" style="margin-left: 10px;"
							@click="handleStop(scope.$index, scope.row)" v-if="navigateIndex==203">终 止</el-link>
						<el-link icon="el-icon-download" :underline="false"
							@click="handleDownload(scope.$index, scope.row)" style="margin-left: 10px;">下 载</el-link>
						<el-link icon="el-icon-s-check" :underline="false"
							@click="handleOpinion(scope.$index, scope.row)" v-if="navigateIndex==204"
							style="margin-left: 10px;">鉴定意见</el-link>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="clinic-table" v-loading="loading" v-else>
			<el-table ref="multipleTable" :key="'anew'" :data="tableData" tooltip-effect="dark" style="width: 100%"
				@selection-change="handleSelectionChange">
				<el-table-column type="selection" width="55">
				</el-table-column>
				<el-table-column prop="caseNo" label="编号" width="150">
					<template slot-scope="scope">{{ scope.row.caseNo }}</template>
				</el-table-column>
				<el-table-column prop="changeByName" label="申请人" width="200">
				</el-table-column>
				<el-table-column prop="changeAt" label="申请时间" width="140">
				</el-table-column>
				<el-table-column prop="changeReason" label="申请理由" width="340" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="passStatusName" label="审核状态" width="150">
				</el-table-column>
				<el-table-column prop="passReason" label="审核意见" width="240" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<div class="table-item" @click="handleChange(scope.$index, scope.row)">
							<i class="el-icon-document"></i>
							审核
						</div>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<pager :total="total" :msgNum="msgNum" ref="pager" @getPage="getPage"></pager>
		<check v-if="checkFlag" :userType="menutype" @closeCheck="checkFlag = false" :id="infoId"></check>
		<checked v-if="checkedFlag" :userType="menutype" @closeChecked="checkedFlag = false"></checked>
		<expertise v-if="expertiseFlag" :userType="menutype" @closeExpertise="expertiseFlag = fasle"></expertise>
		<opinion v-if="opinionFlag" :userType="menutype" @closeOpinion="opinionFlag = false" :infoId="infoId"></opinion>
		<anew v-if="anewFlag" :userType="menutype" @closeAnew="anewFlag = false, getData()" :id="infoId"></anew>
		<el-dialog title="修改鉴定事项" :visible="dialogVisible">
			<div class="dialog-content">
				<el-form ref="matterForm" :model="matterForm" :rules="matterRule" label-width="120px">
					<el-form-item label="案件编号">
						<el-input type="text" v-model="matterForm.series" :disabled="true"></el-input>
					</el-form-item>
					<el-form-item label="新鉴定事项" prop="matter">
						<!-- <el-cascader v-model="newMatter" :options="matterList" :props="{}" @change="handleChange"></el-cascader> -->
						<el-select v-model="matterForm.matter">
							<el-option v-for="(item,index) in matterList" :key="index" :label="item.name"
								:value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="submitForm('matterForm')">保存修改</el-button>
					</el-form-item>
				</el-form>
			</div>
		</el-dialog>
		<el-dialog title="终止鉴定" :visible="stopVisible" @close="stopVisible = false">
			<div class="dialog-content">
				<el-form ref="stopFormRef" :model="stopForm" :rules="stopRules" label-width="120px">
					<div v-loading="loading">
						<el-form-item label="案件编号">
							<el-input type="text" v-model="entrust.caseNo" placeholder="案件编号" disabled></el-input>
						</el-form-item>
						<el-form-item label="委托机构">
							<el-input type="text" v-model="entrust.entrustmentOrganName" placeholder="委托机构"
								disabled></el-input>
						</el-form-item>
						<el-form-item label="联系人">
							<el-input type="text" v-model="entrust.contacts" placeholder="联系人" disabled></el-input>
						</el-form-item>
						<el-form-item label="联系方式">
							<el-input type="text" v-model="entrust.phone" placeholder="联系方式" disabled></el-input>
						</el-form-item>
						<el-form-item label="委托人">
							<el-input type="text" v-model="entrust.entrustmentName" placeholder="委托人"
								disabled></el-input>
						</el-form-item>
						<el-form-item label="地址">
							<el-input type="text" v-model="entrust.address" placeholder="地址" disabled></el-input>
						</el-form-item>
						<el-form-item label="被鉴定人">
							<el-input type="text" v-model="entrust.identifiedName" placeholder="被鉴定人"
								disabled></el-input>
						</el-form-item>
						<el-form-item label="证件号码">
							<el-input type="text" v-model="entrust.identifiedCertificateNo" placeholder="证件号码"
								disabled></el-input>
						</el-form-item>
					</div>
					<el-form-item label="鉴定人" prop="professor">
						<el-select style="width: 100%;" v-model="stopForm.professor" placeholder="请选择鉴定人(多选)" multiple
							allow-create filterable @change="professorChange">
							<el-option v-for="(item,index) in professorList" :key="index" :label="item.name"
								:value="item.name"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="终止意见" prop="opinion">
						<el-input type="textarea" v-model="stopForm.opinion" placeholder="请输入终止意见"></el-input>
					</el-form-item>

					<el-form-item label="上传终止文书" prop="stopFile">
						<el-upload class="upload-demo" :action="uploadSrc" :before-remove="beforeRemove" multiple
							:limit="1" :file-list="fileList" :on-success="handleSuccess" accept=".pdf,.jpg,.jpeg,.png">
							<el-button size="small" type="primary">点击上传</el-button>
							<div slot="tip" class="el-upload__tip">只能上传pdf/jpg/jpeg/png文件</div>
						</el-upload>
					</el-form-item>
					<el-form-item>
						<el-checkbox v-model="stopForm.agree">请同意《真实性承诺书》</el-checkbox>
					</el-form-item>
					<el-form-item>
						<el-button type="danger" plain @click="stopVisible = false">取消</el-button>
						<el-button type="primary" @click="confirmStop">确认</el-button>
					</el-form-item>
				</el-form>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'clinic',
		data() {
			const fileValid = (rule, value, callback) => {
				if (this.stopFile === '') {
					callback(new Error('请上传终止鉴定文件'))
				}
				callback()
			}
			return {
				dateValue: '',
				navigate: [],
				infoId: '',
				navigateIndex: 203,
				tableData: [],
				multipleSelection: [],
				idList: [],
				total: 0,
				msgNum: 0,
				page: 1,
				checkFlag: false,
				checkedFlag: false,
				expertiseFlag: false,
				opinionFlag: false,
				type: [],
				typeVal: '',
				repeat: [],
				repeatVal: '',
				f: '',
				keyword: '',
				loading: true,
				anewFlag: false,
				menutype: '',
				dialogVisible: false,
				matterForm: {
					series: '',
					entrustedMattersName: '',
					matter: ''
				},
				matterRule: {
					matter: [{
						required: true,
						message: '请选择鉴定事项',
						trigger: 'change'
					}]
				},
				matterList: [],
				stopVisible: false,
				stopForm: {
					professor: [],
					opinion: '',
					stopFile: '',
					agree: true
				},
				stopRules: {
					professor: [{
						required: true,
						trigger: 'change',
						message: '请选择鉴定人'
					}],
					opinion: [{
						required: true,
						trigger: 'blur',
						message: '请输入终止意见'
					}],
					stopFile: [{
						required: true,
						validate: fileValid
					}]
				},
				uploadSrc: '',
				fileList: [],
				entrust: {
					caseNo: '',
					entrustmentOrganName: '',
					contacts: '',
					entrustmentName: '',
					identifiedName: '',
					identifiedCertificateNo: '',
					appraisalRecordList: [],
					entrustedMattersName: '',
					supplement: '',
					identificationAgin: '',
					purpose: '',
					requirement: '',
					caseAbstract: '',
					materialCatalogue: '',
					payType: '',
					estimatedCost: '',
					payTypeName: '',
					organization: {
						organName: '',
						licenceNo: '',
						contacts: '',
						phone: '',
						email: '',
					},
				},
				professorList: [],
				stopId: ''
			};
		},
		methods: {
			toggleSelection(rows) {
				if (rows) {
					rows.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row);
					});
				} else {
					this.$refs.multipleTable.clearSelection();
				}
			},
			handleSelectionChange(val) {
				this.idList = []
				this.multipleSelection = val;
				if (this.multipleSelection) {
					for (let i = 0; i < this.multipleSelection.length; i++) {
						this.idList.push(this.multipleSelection[i].id)
					}
				}
			},
			handleCheck(index, row) {
				this.infoId = row.id
				this.menutype = row.caseType
				this.checkFlag = true
			},
			handleExpertise(index, row) {
				this.expertiseFlag = true
			},
			handleDownload(index, row) {
				const loading = this.$loading({
					lock: true,
					text: '请稍候'
				})
				this.$api.getEntrustWord({
					'id': row.id
				}, res => {
					var tempwindow = window.open('_blank');
					tempwindow.location = res.data.EntrustWord
					loading.close()
				})
				// if (this.navigateIndex == 203) {

				// } else {
				// 	window.open(row.filePath)
				// }
			},
			handleOpinion(index, row) {
				this.infoId = row.id
				this.menutype = row.caseType
				this.opinionFlag = true
			},
			getPage(e) {
				this.page = e
				this.getData()
			},
			newClinicData() {
				this.$router.push({
					path: '/clinicForm'
				})
			},
			fetchDataWithKeyword(keyword) {
				this.keyword = keyword
				this.$refs.pager.setCurrent(1)
			},
			getData() {
				this.loading = true
				this.$api.findCaseInformationList({
					'pageNum': this.page,
					'pageSize': '10',
					'organNo': this.$store.state.userInfo.org,
					'startDate': this.f,
					'caseStatus': this.navigateIndex,
					'entrustmentOrganNo': this.typeVal,
					'identificationAgin': this.repeatVal,
					'keyWord': this.keyword
				}, res => {
					this.loading = false
					this.tableData = res.data.dataList.list
					this.total = Math.ceil(res.data.dataList.total / 10)
					this.msgNum = res.data.dataList.total
					this.navigate = res.data.caseList
				})
			},
			exportCase() {
				const loading = this.$loading({
					lock: true,
					text: '请稍候'
				})
				this.$api.exportCaseInfo({
					'idList': this.idList.toString(),
					'organNo': this.$store.state.userInfo.org,
					'startDate': this.f,
					'caseStatus': this.navigateIndex,
					'entrustmentOrganNo': this.typeVal,
					'identificationAgin': this.repeatVal,
					'keyWord': this.keyword
				}, res => {
					var tempwindow = window.open('_blank');
					tempwindow.location = res.data.caseInfoList
					loading.close()
				})
			},

			changeCase(id) {
				this.navigateIndex = id
				this.fetchDataWithKeyword(this.keyword)
			},
			// 审核
			handleChange(index, row) {
				this.infoId = row.id
				this.menutype = row.caseType
				this.anewFlag = true
			},
			// 修改鉴定事项
			editMatter(index, row) {
				if (row.entrustedMattersName != null) {
					return
				}
				this.$api.getCaseMatter({}, res => {
					this.matterList = res.data
					this.matterForm = {
						series: row.caseNo,
						entrustedMattersName: row.entrustedMattersName,
						matter: '',
						id: row.id
					}
					this.dialogVisible = true
				})
			},
			// 保存新鉴定事项
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$api.updateCaseMatter({
							id: this.matterForm.id,
							entrustedMatters: this.matterForm.matter
						}, res => {
							if (res.code == 200) {
								this.$message({
									message: '保存成功！',
									type: 'success'
								})
								this.dialogVisible = false
								this.getData()
							}
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			handleStop(index, row) {
				this.getCaseInfo(row.id)
				this.getProfessorList()
				this.stopVisible = true
				this.stopId = row.id
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${ file.name }？`);
			},
			handleSuccess(res, file) {
				this.stopForm.stopFile = res.data.fileName
			},
			confirmStop() {
				if (!this.stopForm.agree) {
					this.$message({
						message: '请同意《真实性承诺书》！',
						type: 'success'
					})
				}
				this.$confirm('确认要终止这个案件吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.submitStop()
				}).catch(() => {});
			},
			submitStop() {
				this.$api.confirmStop({
					id: this.stopId,
					appraisalOpinion: this.stopForm.opinion,
					documentName: this.stopForm.stopFile,
					appraiser: this.stopForm.professor.join(',')
				}, res => {
					this.$message({
						message: '终止鉴定成功！',
						type: 'success'
					})
					this.getData()
					this.stopVisible = false
				})
			},
			getCaseInfo(id) {
				this.loading = true
				this.$api.findCaseInformationById({
					'id': id
				}, res => {
					this.loading = false
					this.entrust = res.data
				})
			},
			getProfessorList() {
				this.$api.getProfessorList({}, res => {
					this.professorList = res.data
				})
			},
			professorChange(e) {
				console.log(e)
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
			this.uploadSrc = this.$pub.requestUrl + 'uploadStopFile'
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.$api.findSystemDictonaryList({
				'dictType': 15
			}, res => {
				this.type = res.data
			})
			this.$api.getCaseStatusByOrganNo({
				'organNo': this.$store.state.userInfo.org
			}, res => {
				this.navigate = res.data
				this.getData();
			})
			this.$api.findSystemDictonaryList({
				'dictType': 42
			}, res => {
				this.repeat = res.data
			})

		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.clinic {
		width: 100%;
		height: 100%;

		.clinic-navigate {
			width: 100%;
			height: 60px;
			display: flex;
			justify-content: space-between;
			background: #f4f6fa;
			border-bottom: 1px solid #D3D3D3;
			box-sizing: border-box;
			padding: 0px 15px;
			box-sizing: border-box;

			.clinic-left,
			.clinic-right {
				height: 100%;
				display: flex;
				justify-content: space-between;

				.clinic-item {
					height: 100%;
					display: flex;
					justify-content: center;
					align-items: center;
					font-size: 14px;
					position: relative;
					cursor: pointer;

					img {
						width: 20px;
					}

					.clinic-item-underline {
						width: 80px;
						height: 2px;
						background: #007AFF;
						position: absolute;
						left: 50%;
						margin-left: -40px;
						bottom: 0px;
						z-index: 9;
					}
				}

				.clinic-item-select {
					color: #888888;
				}
			}

			.clinic-left {
				.clinic-item {
					width: 120px;
				}
			}

			.clinic-right {
				.clinic-item {
					margin-left: @vue-spacing-row-base;
				}
			}
		}
	}

	.table-item {
		height: 100%;
		float: left;
		margin-right: 16px;
		cursor: pointer;
		padding-right: 10px;
		box-sizing: border-box;
	}

	.table-item:hover {
		background: #F0F0F0;
	}
</style>